import { StintopediaEdit } from './StintopediaEdit';
import { StintopediaList } from './StintopediaList';

export const edit = StintopediaEdit;
export const list = StintopediaList;
